import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import EKOMITITLE from "../../images/f39fdf15-e87c-4118-81bd-7bd3f882b34d.png";

const REACT_APP_EKOMI_CONNECT_CLIENT_ID_stage =
  "98_64xdb5yzjsgswwooswkw00sk0sccwo044088oksgo0c0c444c4";
const REACT_APP_EKOMI_CONNECT_CLIENT_ID_prod_truzzer =
  "90_rfldkfoq4hwggk04skcs40wg80w48ocoggs8gs0g0gsgoscck";
const REACT_APP_EKOMI_CONNECT_CLIENT_ID_prod_empfehlio =
  "90_rfldkfoq4hwggk04skcs40wg80w48ocoggs8gs0g0gsgoscck";

function Login() {
  const [loginActive, setLoginActive] = useState(true);
  const [supportMail, setsupportMail] = useState("hello@truzzer.com");
  const navigateTo = useNavigate();
  const [authCode, setAuthCode] = useState(null);
  const [accessToken, setAccessToken] = useState(null);
  const [pageName, setName] = useState("");
  const [ekomiConnectUrl, setEkomiConnectUrl] = useState("");
  const [redirectUrl, setRedirectUrl] = useState("");
  const [redirectUrlLogin, setRedirectUrlLogin] = useState("");
  const [ekomiConnectClient, setEkomiConnectClient] = useState("");
  const [buttonLoginText, setButtonLoginText] = useState(
    "Login with eKomi connect"
  );
  const pageTitleTruzzer = "Truzzer";
  const pageTitleEmpfehlio = "Empfehlio";
  const [footerText, setFooterText] = useState(
    "Problems logging in? Click here to contact support"
  );
  const [isLogin, setIsLogin] = useState(false);
  const [isLoginText, setIsLoginText] = useState(
    "You are already logged in with a connect account, please logout first."
  );
  const [logoutText, setLogoutText] = useState("Logout of Connect");

  useEffect(() => {
    const hostname = window.location.hostname;
    let config = {
      name: "",
      ekomiConnectUrl: "",
      ekomiConnectClient: "",
      redirectUrl: "",
      redirectUrlLogin: "",
    };
    config.name = pageTitleTruzzer;
    if (hostname.startsWith(pageTitleTruzzer.toLowerCase())) {
      config.name = pageTitleTruzzer;
    } else if (hostname.startsWith(pageTitleEmpfehlio.toLowerCase())) {
      config.name = pageTitleEmpfehlio;
      setsupportMail("info@empfehlio.de");
      setFooterText(
        "Probleme beim Einloggen? Klicken Sie hier, um den Support zu kontaktieren"
      );
      setButtonLoginText("Mit eKomi Connect einloggen");
      setIsLoginText(
        "Sie sind bereits mit einem Connect-Konto angemeldet, bitte melden Sie sich zuerst ab."
      );
      setLogoutText("Ausloggen von Connect");
    }

    if (hostname.includes("coddle")) {
      config.ekomiConnectUrl = "https://connect.coddle.de";
      config.ekomiConnectClient = REACT_APP_EKOMI_CONNECT_CLIENT_ID_stage;
      config.redirectUrl = "https://truzzer.coddle.de/auth/ekomi/callback";
      config.redirectUrlLogin = "https://truzzer.coddle.de/login";
    } else if (hostname.includes("ekomiapps")) {
      config.ekomiConnectUrl = "https://login.ekomiapps.de";
      config.ekomiConnectClient =
        config.name === pageTitleEmpfehlio
          ? REACT_APP_EKOMI_CONNECT_CLIENT_ID_prod_empfehlio
          : REACT_APP_EKOMI_CONNECT_CLIENT_ID_prod_truzzer;
      config.redirectUrl =
        config.name === pageTitleEmpfehlio
          ? `https://empfehlio.ekomiapps.de/auth/ekomi/callback`
          : `https://truzzer.ekomiapps.de/auth/ekomi/callback`;
      config.redirectUrlLogin =
        config.name === pageTitleEmpfehlio
          ? `https://empfehlio.ekomiapps.de/login`
          : `https://truzzer.ekomiapps.de/login`;
    } else {
      // Localhost or other development environment (including Replit)
      config.ekomiConnectUrl = "https://connect.coddle.de"; // Default to staging for development
      config.ekomiConnectClient = REACT_APP_EKOMI_CONNECT_CLIENT_ID_stage;
      // Use current location for redirect URLs (works for both localhost and Replit)
      const currentOrigin = window.location.origin;
      config.redirectUrl = `${currentOrigin}/auth/ekomi/callback`;
      config.redirectUrlLogin = `${currentOrigin}/login`;
    }

    setName(config.name);
    setEkomiConnectUrl(config.ekomiConnectUrl);
    setEkomiConnectClient(config.ekomiConnectClient);
    setRedirectUrl(config.redirectUrl);
    setRedirectUrlLogin(config.redirectUrlLogin);
  }, []);

  function setCookieExpires(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value}; ${expires}; path=/; secure; samesite=strict`;
  }
  useEffect(() => {
    const fetchAccessToken = async (authCodeVal) => {
      const maxRetries = 3;
      const retryDelay = 500; // delay in milliseconds (1 second)
      let retries = 0;
      let response = null;
      let websiteFlagValue = 0;
      if (
        window.location.hostname.startsWith(pageTitleEmpfehlio.toLowerCase())
      ) {
        websiteFlagValue = 1;
      }

      while (retries < maxRetries) {
        try {
          response = await axios.post("/api/login", {
            authCode: authCodeVal,
            websiteFlag: websiteFlagValue,
          });
          return response; // Exit the function if the request is successful
        } catch (error) {
          console.error("Failed to get access token", error);
          if (error.response && error.response.status === 400) {
            console.error("Invalid auth code. Exiting retry loop.");
            break;
          }
          retries++;
          if (retries < maxRetries) {
            await new Promise((resolve) => setTimeout(resolve, retryDelay));
          } else {
            console.error("Max retries reached. Unable to get access token.");
          }
        }
      }

      return null; // Return null if all retries fail
    };

    const findUserRoles = async (accessToken) => {
      try {
        const response = await axios.post("/api/user-roles", {
          accessToken: accessToken,
        });
        return response.data;
      } catch (error) {
        console.error("Failed to get user roles", error);
      }
    };
    const handleAuthCode = async () => {
      if (authCode !== null) {
        try {
          const response = await fetchAccessToken(authCode);
          if (response && response.data) {
            if (response.data.error) {
              if (response.data.error === "invalid_grant") {
                setAuthCode(null);
                setCookieExpires("landingpageAuthCode", "", -1);
              }
            } else {
              const access_token = response.data.access_token;
              setAccessToken(access_token);
              setCookieExpires("landingpageAccessToken", access_token, 14);
              setCookieExpires("landingpageAuthCode", "", -1);
            }
          }
        } catch (error) {
          console.error("Failed to get access token", error);
        }
      }
    };

    handleAuthCode();
  }, [authCode]);
  useEffect(() => {
    const findUserRoles = async (accessToken) => {
      try {
        const response = await axios.post("/api/user-roles", {
          accessToken: accessToken,
        });
        return response.data;
      } catch (error) {
        console.error("Failed to get user roles", error);
        return { roles: "not found" };
      }
    };
    const getCookie = (name) => {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(";").shift();
    };

    const checkAuthCodeCookie = async () => {
      const authCode = getCookie("landingpageAuthCode");
      const accessToken = getCookie("landingpageAccessToken");
      if (accessToken === undefined) {
      } else if (accessToken) {
        setAccessToken(accessToken);
        const userInfo = await findUserRoles(accessToken);
        if (userInfo.roles !== "not found") {
          setCookieExpires("landingpageAuthCode", "", -1);
          clearInterval(intervalId);
          if (userInfo.template) {
            if (userInfo.template.website_flag === 0) {
              if (window.location.hostname !== "empfehlio.ekomiapps.de") {
                navigateTo(
                  `/truzzer${userInfo.user.username}-truzzer${userInfo.user.id}-config`
                );
              } else {
                setCookieExpires("landingpageAuthCode", "", -1);
                setCookieExpires("landingpageAccessToken", "", -1);
                navigateTo("/login");
              }
            } else if (userInfo.template.website_flag === 1) {
              if (window.location.hostname !== "truzzer.ekomiapps.de") {
                navigateTo(
                  `/empfehlio${userInfo.user.username}-empfehlio${userInfo.user.id}-config`
                );
              } else {
                setCookieExpires("landingpageAuthCode", "", -1);
                setCookieExpires("landingpageAccessToken", "", -1);
                navigateTo("/login");
              }
            }
          } else if (userInfo.account) {
            if (window.location.hostname !== "empfehlio.ekomiapps.de") {
              navigateTo(
                `/truzzer${userInfo.user.username}-truzzer${userInfo.user.id}-config`
              );
            } else if (window.location.hostname !== "truzzer.ekomiapps.de") {
              navigateTo(
                `/empfehlio${userInfo.user.username}-empfehlio${userInfo.user.id}-config`
              );
            } else {
              navigateTo(
                `/truzzer${userInfo.user.username}-truzzer${userInfo.user.id}-config`
              );
            }
          } else {
            setCookieExpires("landingpageAuthCode", "", -1);
            setCookieExpires("landingpageAccessToken", "", -1);
            navigateTo("/login");
          }
        } else {
          setIsLogin(true);
        }
      }
      if (authCode) {
        setAuthCode(authCode);
      }
    };

    // Check for the cookie initially
    let intervalId;
    // Set up an interval to check for the cookie periodically
    if (loginActive) {
      intervalId = setInterval(checkAuthCodeCookie, 1000); // Check every second
      checkAuthCodeCookie();
      // Clear the interval when the component unmounts
      return () => clearInterval(intervalId);
    }
  }, [loginActive]);
  const handleLogout = async () => {
    setCookieExpires("landingpageAccessToken", "", -1);
    setCookieExpires("landingpageAuthCode", "", -1);
    try {
      window.location.href = `${ekomiConnectUrl}/force-logout?redirect=${encodeURIComponent(
        redirectUrlLogin
      )}`;
    } catch (error) {
      console.error("Failed to fetch user data", error);
    }
    setLoginActive(false);
    setIsLogin(false);
  };
  function openPopup(url, type, w, h) {
    var left = window.width / 2 - w / 2;
    var top = window.height / 2 - h / 2;
    var myWindow = window.open(
      url,
      type,
      "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=" +
        w +
        ", height=" +
        h +
        ", top=" +
        top +
        ", left=" +
        left
    );
  }
  const getAuthCode = () => {
    setLoginActive(true);
    openPopup(
      `${ekomiConnectUrl}/oauth/v2/auth?client_id=${ekomiConnectClient}&redirect_uri=${redirectUrl}&response_type=code`,
      "ekomi-connect",
      400,
      400
    );
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-100 to-gray-200">
      <header className="flex bg-white shadow-sm">
        <img src={EKOMITITLE} className="my-4 ml-10 h-12" alt="eKomi Logo" />
      </header>
      <div className="flex items-center justify-center min-h-[calc(100vh-80px)]">
        <div className="bg-white p-8 rounded-lg shadow-lg md:w-full max-w-md mx-4 transform transition-all">
          <h3 className="text-2xl font-semibold text-gray-800 mb-1">{pageName}</h3>
          <div className="mt-2 border-t-2 border-green-500 w-16 mb-6" />
          <div className="mb-8">
            {isLogin ? (
              <>
                <div className="text-red-500 text-sm mb-4 p-3 bg-red-50 rounded-md border border-red-200">{isLoginText}</div>
                <button
                  onClick={() => handleLogout()}
                  className="w-full bg-green-600 text-white py-3 px-4 text-base font-medium rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
                >
                  {logoutText}
                </button>
              </>
            ) : (
              <button
                onClick={() => getAuthCode()}
                className="w-full bg-green-600 text-white py-3 px-4 text-base font-medium rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
              >
                {buttonLoginText}
              </button>
            )}
          </div>
          <div className="text-center pt-4 border-t border-gray-200">
            <a
              href={`mailto:${supportMail}`}
              className="text-sm text-gray-600 hover:text-green-600 transition duration-200 inline-flex items-center gap-2"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              {footerText}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
